import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import axios from "axios";
import { toast } from "react-toastify";
import Crop from "../../shared/crop";

const AddCategory = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [imagePreview, setImagePreview] = useState("");
  const [isError, setError] = useState(false);
  const [formValue, setFormValue] = useState({
    id: null,
    name: "",
    image: "",
    image_url: "",
  });

  const saveCategory = () => {
    if (formValue.name) {
      if (!id && !formValue.image) {
        setError(true);
        toast.error("Please enter valid details", {
          autoClose: 3000,
          position: "top-right",
        });
        return false;
      }
      setError(false);
      var prodFormData = new FormData();
      if (formValue.image) {
        prodFormData.append("image", formValue.image);
      }
      const pUrl = id ? API_URL.CATEGORY_UPDATE : API_URL.CATEGORY_SAVE;
      axios.post(pUrl, formValue).then((res) => {
        if (res.data.status === 1) {
          if (id) {
            toast.success("Updated", {
              autoClose: 3000,
              position: "top-right",
            });
            setTimeout(() => {
              navigate("/admin/category", { replace: true });
            }, 100);
          } else {
            resetForm();
            toast.success("Saved", { autoClose: 3000, position: "top-right" });
            navigate("/admin/category", { replace: true });
          }
        }
      });
    }
  };

  const resetForm = () => {
    setFormValue({
      id: null,
      name: "",
      image_url: "",
    });
  };

  const onEdit = () => {
    axios.post(API_URL.CATEGORY_GET, { id: id }).then((res) => {
      if (res.data.status === 1) {
        setFormValue({
          id: res.data.data.id,
          name: res.data.data.name ? res.data.data.name : "",
          image: null,
          image_url: res.data.data.image ? res.data.data.image : "",
        });
      }
    });
  };

  const isValidForm = () => {
    return formValue.name;
  };

  useEffect(() => {
    id && onEdit();
  }, [id]);

  return (
    <>
      <div className="page-header">
        <div className="content-page-header">
          <h5>{id ? "Edit" : "Add"} Category</h5>
          <div className="list-btn">
            <ul className="filter-list">
              <li>
                <Link to={"/admin/category"} className="btn btn-secondary">
                  <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <form onSubmit={(event) => event.preventDefault()}>
            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="form-group">
                  <label>Name*</label>
                  <input
                    type="text"
                    name="name"
                    value={formValue.name}
                    className="form-control"
                    id="name"
                    onChange={(event) => {
                      setFormValue({ ...formValue, name: event.target.value });
                    }}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>Image</label>
                      <Crop
                        imagePreview={imagePreview}
                        cropShape={"rect"}
                        guid={""}
                        onChangeCropper={async ({
                          fileCropped,
                          fileCroppedBase64,
                        }) => {
                          setFormValue({
                            ...formValue,
                            image: fileCroppedBase64,
                          });
                          setImagePreview(fileCroppedBase64);
                          //   await uploadFile(fileCropped)
                        }}
                      />
                    </div>
                  </div>
                  {id && (
                    <div className="col-md-12">
                      <label>Preview</label>
                      <div>
                        <a
                          href={formValue.image_url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={formValue.image_url}
                            height={100}
                            width={100}
                            alt="product_image"
                          />
                        </a>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="form-group text-end">
                <button
                  type="submit"
                  onClick={saveCategory}
                  disabled={!isValidForm()}
                  className="btn btn-primary"
                >
                  Save Category
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddCategory;
